import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectUserCityCode} from 'modules/locations/selectors';
import {ICity} from 'modules/locations/models';
import {CookieService} from 'core/services/CookieService';
import {CITY_CODE_KEY_CLIENT} from '../constants';

export const useUserCityCode = (): ICity['code'] | null => {
    const cookiesService = CookieService.getInstance();

    return useAppSelector(selectUserCityCode) || cookiesService.get(CITY_CODE_KEY_CLIENT) || null;
};
